import { Intent } from 'src/shared/intent';

export const action = 'payment-result';
export type PaymentResultIntent = Intent<[{ code?: string; message: string } | null]>;
export const createPaymentResultIntent = (error?: { message: string; code?: string }): PaymentResultIntent =>
  new Intent({ action, params: [error || null] });
export const isPaymentIntent = (intent: Intent): intent is PaymentResultIntent => intent.action === action;
